import { Outlet, createFileRoute } from "@tanstack/react-router";

// Layout: registry in ./organisations/index.tsx, record in ./organisations/$tenantPublicId.tsx.
export const Route = createFileRoute("/(app)/ops/organisations")({
  component: () => <Outlet />,
});
